import { defineStore } from 'pinia';
import { ref } from 'vue';

import { crossbeamApi } from '@/api';
import { FileUpload } from '@/types/file_uploads';

import { initStore } from './store-utils';

export const useFileUploadsStore = defineStore('FileUploads', () => {
  const currentUploads = ref<FileUpload[]>([]);
  const currentUploadNames = ref<string[]>([]);
  const uploadTables = ref<string[]>([]);

  const { initError, ready, readySync, running, refresh } = initStore(
    async () => {
      const [tablesResponse, fileUploadsResponse] = await Promise.all([
        crossbeamApi.GET('/v0.3/file-uploads/tables'),
        crossbeamApi.GET('/v0.2/file-uploads'),
      ]);
      const err = tablesResponse.error || fileUploadsResponse.error;
      if (err) {
        throw err;
      }
      currentUploads.value = fileUploadsResponse.data.items;
      const currentTableNames = currentUploads.value.map(
        ({ table_name: tableName }) => tableName,
      );
      currentUploadNames.value = [...new Set(currentTableNames)];
      uploadTables.value = tablesResponse.data.items;
    },
  );

  refresh({ useCache: true });

  function getByCSVName(name: string) {
    return uploadTables.value.find(
      (fileName) => fileName.trim().toLowerCase() === name.trim().toLowerCase(),
    );
  }

  return {
    error: initError,
    ready,
    readySync,
    running,
    refreshFileUploadsStore: refresh,
    currentUploads,
    uploadTables,
    currentUploadNames,
    getByCSVName,
  };
});
